import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { BsCheck2Square } from "react-icons/bs";
import { useSelector } from "react-redux";
import { FcFinePrint } from "react-icons/fc";

const ViewGrn = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [refresh, setRefresh] = useState(false);
  let userData = useSelector((store) => store.login.user);
  let { id } = useParams();
  const navigate = useNavigate();

  //   const duplicatePO = () => {
  //     navigate(`/purchase-order/new?duplicate=${id}`);
  //   };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/grn/getGrnById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  const handleApprovePO = (values, actions) => {
    values = { ...values, approveStatus: true };
    setLoading(true);
    performRequest("PATCH", `/grn/updateGrn/${id}`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "GRN updated successfully!");
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcFinePrint></FcFinePrint>GRN System
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View GRN System</h2>
            </div>

            <div className="card-body">
              {data?.vendor && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Vendor</label>
                  <div className="w-100 col">
                    <a
                      href={`/purchase-vendor-management/view-vendor/${data?.vendor}`}
                    >
                      View
                    </a>
                  </div>
                </div>
              )}

              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">PO type</label>
                  <div className="w-100 col">
                    {(data?.poType || "N/A").toUpperCase()}
                  </div>
                </div>
              )} */}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Vendor purchase order for
                  </label>
                  <div className="w-100 col">
                    {(data?.vendorPurchaseOrderFor || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Vendor purchase order date
                  </label>
                  <div className="w-100 col">
                    {(data?.vendorPurchaseOrderDate || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Project</label>
                  <div className="w-100 col">
                    {(data.project || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Country of supply
                  </label>
                  <div className="w-100 col">
                    {(data?.countryOfSupply || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Place of supply
                  </label>
                  <div className="w-100 col">
                    {(data?.placeOfSupply || "N/A").toUpperCase()}
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Vendor invoice number
                  </label>
                  <div className="w-100 col">
                    {(data?.vendorInvoiceNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Payment priority
                  </label>
                  <div className="w-100 col">
                    <div className="w-100 col">
                      {data?.paymentPriority ? (
                        data?.paymentPriority === "low" ? (
                          <span className="text-white badge bg-success">
                            {data?.paymentPriority}
                          </span>
                        ) : (
                          <span className="text-white badge bg-warning">
                            {data?.paymentPriority}
                          </span>
                        )
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Approval status
                  </label>
                  <div className="w-100 col">
                    <div className="w-100 col">
                      {data?.approveStatus ? (
                        <span className="text-white badge bg-success">
                          approved
                        </span>
                      ) : (
                        <span className="text-white badge bg-warning">
                          pending
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Payment amount
                  </label>
                  <div className="w-100 col">
                    {data?.paymentAmount ? `₹${data?.paymentAmount}` : "N/A"}
                  </div>
                </div>
              )}

              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Payment type</label>
                  <div className="w-100 col">
                    {(data?.paymentType || "N/A").toUpperCase()}
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Notes</label>
                  <div className="w-100 col">
                    {(data?.notes || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Proforma invioce
                  </label>
                  <div className="w-100 col">
                    {data.performaInvoice ? (
                      <LazyImageComponent
                        width="70%"
                        src={data.performaInvoice}
                        alt={"performaInvoice"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )} */}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Tax invoice</label>
                  <div className="w-100 col">
                    {data.taxInvoice ? (
                      <LazyImageComponent
                        width="70%"
                        src={data.taxInvoice}
                        alt={"taxInvoice"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )} */}

              <hr />
              <h2>Line Items</h2>
              <hr />
              {data &&
                data.lineItems?.map((lineItem, index) => {
                  return (
                    <div key={index}>
                      <h2>{++index}.</h2>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Particulars
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.particulars || "N/A").toUpperCase()}
                        </div>
                      </div>
                      {/* <div className="mb-3 row">
                        <label className="w-25 form-label col-3">SKU</label>
                        <div className="w-100 col">
                          <b>{(lineItem?.sku || "N/A").toUpperCase()}</b>
                        </div>
                      </div> */}
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item unit
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemUnit || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item quantity
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemQuantity || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Recived quantity
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.recivedQty || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item price:
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemPrice || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          GST rate (%)
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.gstRate || "N/A").toUpperCase()}
                        </div>
                      </div>
                      {/* <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Discount (%)
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.discount || "N/A").toUpperCase()}
                        </div>
                      </div> */}
                      {/* <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Delivery date
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.deliveryDate || "N/A").toUpperCase()}
                        </div>
                      </div> */}
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Total without gst
                        </label>
                        <div className="w-100 col">
                          {lineItem?.totalWithoutGst || "N/A"}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Total with gst
                        </label>
                        <div className="w-100 col">
                          {lineItem?.totalWithGst || "N/A"}
                        </div>
                      </div>
                      {/* <div className="mb-3 row">
                        <label className="w-25 form-label col-3">Notes</label>
                        <div className="w-100 col">
                          {(lineItem?.notes || "N/A").toUpperCase()}
                        </div>
                      </div> */}
                      <hr />
                    </div>
                  );
                })}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <button
                  onClick={() => handleApprovePO()}
                  disabled={data?.approveStatus}
                  className="btn mx-1 mt-2 btn-success"
                >
                  <BsCheck2Square className="fs-2 me-2" />
                  APPROVE GRN
                </button>

                <SimpleButton
                  buttonText={"generate pdf"}
                  href={`/preview-grn-items/${id}`}
                />
                <button
                  type="button"
                  className="btn mx-1 mt-2 btn-primary"
                  disabled={data?.approveStatus}
                  onClick={() => {
                    navigate(`/edit-grn-items/${id}`);
                  }}
                >
                  Edit GRN
                </button>
                {/* <SimpleButton buttonText="Duplicate" onClick={duplicatePO} /> */}
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewGrn;
